module.exports = __webpack_public_path__ + "img/restricted-access.7394841d.svg";